import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-ui-feedback',
  templateUrl: 'ui-feedback.component.html',
  styleUrls: ['ui-feedback.component.scss'],
  standalone: false
})
export class UIFeedbackComponent {
  @Input() feedback: 'error' | 'success' | 'loading';
  @Input() title: string;
  @Input() description: string;
  @Input() actionDescription: string;
  @Input() checkboxStatus: boolean;
  @Output() changeCheckbox = new EventEmitter<Event>();

  emitChangeCheckbox(event: Event): void {
    this.changeCheckbox.emit(event);
  }

  getIcon(): string {
    return `icon-i-${this.feedback === 'success' ? 'checkmark-circle' : 'close-circle'}`;
  }
}
